import { Schema, z } from 'zod';
import { FieldValue, FieldValueSchema } from './schema';

export type JSONValue = FieldValue | null | undefined;

export const JSONValueSchema: Schema<JSONValue> =
  FieldValueSchema.nullable().optional();

export type EnrichmentFieldConfiguration = {
  readonly type: string;
} & Record<string, JSONValue>;

export const EnrichmentFieldConfigurationSchema: Schema<EnrichmentFieldConfiguration> =
  z.intersection(
    z.object({
      type: z.string()
    }),
    z.record(z.string(), JSONValueSchema)
  );
